export const listHeaderDeposit = [
  "Date",
  "Transaction ID",
  "Method",
  // "BankType",
  "Amount",
  "Status * Selection of Deposit",
  // "Withdraw",
  // "P2P Transfer",
];
export const listHeaderTransactionAll = [
  "Date",
  "Method",
  "Amount",
  "Status",
  "Bank Name",
  "Bank Account Number",
  "Promotion Name",
  "Reward Amount",
  "Total Amount",
  // "Is Reward",
];
export const listHeaderWithdraw = [
  "Date",
  "Bank Name",
  "Bank Account Number",
  "Amount",
  "Status",
  "Remark",
];
export const listHeaderRebated = ["Date", "Total Valid Turnover", "Amount"];

export const listHeaderReward = [
  "Date",
  "Transaction ID",
  "Method",
  "Bonus Amount",
  "Required Turnover",
  "Status",
];
export const listHeaderTransferPointHistory = [
  "From",
  "To",
  "Report Date",
  "Amount",
];
export const listHeaderPromotion = [
  "Date",
  "Reward",
  "Promotion Name",
  "Cash Rebate Turnover",
  "Promotion Turnover",
  "Current Promotion Turnover",
  "Distance",
  "Downline Player ID",
  "Is Reward",
  "Status",
];
